<template>
<div>
    <b-row>
        <b-col md="12" class="my-1">
            <h3 class="text-themecolor">{{$t('klanten.klanten')}}</h3>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <div class="card">
                <div class="card-body">
                    <!-- User Interface controls -->
                    <b-row>
                        <b-col md="12" class="my-1">
                            <b-form-group class="mb-0">
                                <b-input-group>
                                    <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- User Interface controls -->
                    <!-- Main table element -->
                    <b-row>
                        <b-col md="12">
                            <b-table class="table-hover"
                                     show-empty
                                     v-if="companies" 
                                     :items="companies" 
                                     :empty-text='getEmptyText(count)'
                                     :fields="fields"
                                     :current-page="currentPage" 
                                     :per-page="perPage" 
                                     :filter="filter" 
                                     @filtered="onFiltered" 
                                     @row-clicked="onRowClicked"
                                     :busy="count == -1">
                                     <template v-slot:table-busy>
                                        <PreLoader/>
                                     </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- Main table element -->

                    <!-- Pagination controls -->
                    <b-row>
                        <b-col md="12" lg="5">
                            <b-form-group label-cols :label="$t('datatables.perpagina')">
                                <b-form-select :options="pageOptions" v-model="perPage" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" lg="7">
                            <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                        </b-col>
                    </b-row>
                    <!-- Pagination controls -->
                </div>
            </div>
        </b-col>
    </b-row>
</div>
</template>

<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: `customers-index`,
    components: {PreLoader},
    data() {
        return {
            command: {},
            currentPage: 1,
            perPage: 50,
            pageOptions: [50, 100, 200],
            filter: null,
            count: -1
        }
    },
    computed: {
        fields() { 
            return [{
                    key: 'fmCustomerId',
                    label: this.$i18n.t('datatables.klantid'),
                    sortable: true
                },
                {
                    key: 'name',
                    label: this.$i18n.t('datatables.naam'),
                    sortable: true
                },{
                    key: 'id',
                    label: this.$i18n.t('datatables.id'),
                    sortable: true
                }
            ]
        },
        ...mapGetters({
            companies: 'fm/companies'
        }),
    },
    methods: {
        ...mapActions('fm', ['all', 'search']),
        onFiltered(filteredItems) {
            this.count = filteredItems.length;
            this.currentPage = 1
        },
        onRowClicked(item) {
            this.$router.push({
                name: `customers:detail`,
                params: {
                    companyId: item.id
                }
            });
        },
        getEmptyText,
    },
    created() {
        let vm = this;
        vm.all({
            resource: 'companies'
        })
         .then((data) => {
            vm.count = data.result.length;
        });
    },
}
</script>
